let locks = []
let initialClientY = -1

export const preventDefault = (rawEvent) => {
  const e = rawEvent || window.event

  if (e.touches.length > 1) {
    return true
  }

  if (e.preventDefault && e.cancelable) {
    e.preventDefault()
  }

  return false
}

const isTargetElementTotallyScrolled = (targetElement) => {
  return targetElement
    ? targetElement.scrollHeight - targetElement.scrollTop <=
        targetElement.clientHeight
    : false
}

const handleScroll = (event, targetElement) => {
  const clientY = event.targetTouches[0].clientY - initialClientY

  if (targetElement && targetElement.scrollTop === 0 && clientY > 0) {
    return preventDefault(event)
  }

  if (isTargetElementTotallyScrolled(targetElement) && clientY < 0) {
    return preventDefault(event)
  }

  event.stopPropagation()
  return true
}

export const disableBodyScroll = (targetElement) => {
  if (locks.some((lock) => lock.targetElement === targetElement)) {
    return
  }

  const lock = {
    targetElement,
  }

  locks = [...locks, lock]

  targetElement.ontouchstart = (event) => {
    if (event.targetTouches.length === 1) {
      initialClientY = event.targetTouches[0].clientY
    }
  }
  targetElement.ontouchmove = (event) => {
    if (event.targetTouches.length === 1) {
      handleScroll(event, targetElement)
    }
  }
}

export const clearAllBodyScrollLocks = () => {
  locks.forEach((lock) => {
    lock.targetElement.ontouchstart = null
    lock.targetElement.ontouchmove = null
  })

  initialClientY = -1

  locks = []
}
